<script>
    import { onMount } from "svelte";
    import { getCurrentGames } from "./sb";
    import { state, ui, prefs } from "./stores";
    import { format } from 'timeago.js';
    import { getItems, subscribeTable, unsubscribeTable } from "./anydb";
    import NetworkGamesTable from "./NetworkGamesTable.svelte";

    let games = [];
    let requests = [];
    let loadError = '';
    $: yourGames = games.filter(g => g.captain1_username == $prefs.username || g.captain2_username == $prefs.username);
    $: otherGames = games.filter(g => g.captain1_username != $prefs.username && g.captain2_username != $prefs.username && g.public);

    onMount(() => {
        const interval = setInterval(updateTimes, 1000);
        return () => {
            clearInterval(interval);
            unsubscribeTable('current_games');
            if($state.hostUsername != $prefs.username || $ui.tab != 'game' || !$state.advertised) unsubscribeTable('stcc_requests');
        }
    })

    function updateTimes(){
        for(let g of games){
            // PocketBase's own field is `created`; `created_at` was never set, so
            // the Started column had nothing to format.
            let started = g.created || g.created_at;
            g.times = {
                created_at: started ? format(started, 'en_GB') : '',
                whenSaved: g.whenSaved ? format(g.whenSaved, 'en_GB') : ''
            }
        }
    }

    function replaceOrAdd(list, record){
        let i = list.findIndex(g => g.id == record.id);
        if(i == -1) return [record, ...list];   // writing to index -1 did nothing
        list[i] = record;
        return list;
    }

    async function loadGames(){
        loadError = '';
        games = await getCurrentGames();
        subscribeTable('current_games', (e) => {
            if(e.action == 'delete') games = games.filter(g => g.id != e.record.id);
            if(e.action == 'update') games = replaceOrAdd(games, e.record);
            if(e.action == 'create') games = [e.record, ...games];
            updateTimes();
        })
        let response = await getItems('stcc_requests');
        if(response.error) loadError = response.error.message || 'Unable to load join requests.';
        if(response.data) requests = response.data;
        subscribeTable('stcc_requests', (e) => {
            if(e.action == 'delete') requests = requests.filter(g => g.id != e.record.id);
            if(e.action == 'update') requests = replaceOrAdd(requests, e.record);
            if(e.action == 'create') requests = [e.record, ...requests];
        });
        updateTimes();
    }

</script>

{#await loadGames()}
    <p class="games-message">Loading current games...</p>
{:then}
    {#if loadError}
        <p class="games-message error">{loadError}</p>
    {/if}

    <h2>Your games</h2>
    {#if yourGames.length > 0}
        <NetworkGamesTable {requests} games={yourGames} />
    {:else}
        <p class="games-message">No active games for {$prefs.username || 'this player'}.</p>
    {/if}

    <h2>Other games</h2>
    {#if otherGames.length > 0}
        <NetworkGamesTable {requests} games={otherGames} />
    {:else}
        <p class="games-message">No public games are waiting right now.</p>
    {/if}
{:catch error}
    <p class="games-message error">Unable to load current games: {error.message}</p>
{/await}

<style>
    .games-message {
        margin: 1vmin 0 2vmin;
        font-style: italic;
    }

    .error {
        color: salmon;
        font-weight: bold;
    }
</style>
